import { postApi } from "../utils/apiHelper";

// Public client intake / meeting request → CRM (client_portal) backend.
// Returns { success: true, tracking_code: "..." } on success.
export const submitClientInquiry = (data) => {
  const header = {
    headers: { 'Content-Type': 'application/json' },
  };
  return postApi('/api/v1/inquiries/public/', data, header);
};
